<template>
  <div>
    <el-card>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="待接受任务" name="first"></el-tab-pane>
        <el-tab-pane label="历史任务查询" name="second"></el-tab-pane>
        <div class="btn-group">
          <!-- 年份选择 -->
          <div class="rowpart">
            <el-date-picker
              style="width: 120px"
              v-model="year"
              type="year"
              placeholder="选择年"
              value-format="YYYY"
            >
            </el-date-picker>
          </div>

          <!-- 季度选择 -->
          <div class="rowpart">
            <SeasonSelect
              v-model="season"
              @season="this.season = $event"
            ></SeasonSelect>
          </div>

          <!-- 月份选择 -->
          <div class="rowpart">
            <MonthSelect
              v-model="month"
              @month="this.month = month"
            ></MonthSelect>
          </div>

          <!-- 来源选择 -->
          <div class="ratio-group">
            <label class="radio_label"
              ><span class="textsmall">来源:</span></label
            >
            <el-radio-group v-model="taskSource">
              <template v-for="source in taskSources" :key="source.value">
                <el-radio :label="source.label"></el-radio>
              </template>
            </el-radio-group>
          </div>
        </div>

        <!-- 表格 -->
        <el-table
          :data="
            taskList.slice((currentPage - 1) * pagesize, currentPage * pagesize)
          "
          border
          style="width: 100%"
          height="600"
          class="diffrow"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :default-sort="{ prop: 'taskId' }"
        >
          <el-table-column type="selection" width="55" fixed />
          <template v-for="column in taskAcceptTable" :key="column.label">
            <el-table-column
              :prop="column.prop"
              :label="column.label"
              width="180"
              :formatter="formatter"
            >
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160" fixed="right">
            <template #default="scope">
              <el-button
                v-if="activeTab == 'first'"
                type="text"
                @click="handleAccept(scope.$index, scope.row)"
                >确认接受</el-button
              >
              <el-button v-else type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-block">
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="taskList.length"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>

        <div class="bottom-btn">
          <el-popconfirm
            title="确认接收指标?"
            @confirm="doAccept"
            confirm-button-text="是"
            cancel-button-text="否"
          >
            <template #reference>
              <el-button type="primary">确认接收</el-button>
            </template>
          </el-popconfirm>
        </div>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
// @ is an alias to /src
import TaskAccept from "../api/TaskAccept";
export default TaskAccept;
</script>

<style scoped lang="scss">
.btn-group {
  display: flex;
  align-items: center;
}

.rowpart {
  margin-right: 10px;
  width: 120px;
}

.ratio-group {
  display: flex;
  align-items: center;
}

.el-radio {
  margin-right: 5px;
}

.textsmall {
  font-size: 14px;
}

.radio_label {
  margin: 5px;
}

.diffrow {
  margin-top: 20px;
}

.pagination-block {
  margin-top: 20px;
}

.bottom-btn {
  display: flex;
  justify-content: end;
}
</style>